var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell"},[_c('span',{staticClass:"grid-cell--title"},[_vm._v(_vm._s(_vm.data.title))]),_c('br'),_c('span',{staticClass:"grid-cell--subtitle"},[_vm._v(_vm._s(_vm.data.subject))])])
}
var staticRenderFns = []

export { render, staticRenderFns }